var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",function(){return _vm._l((_vm.widths),function(width,index){return _c('div',{key:index,staticClass:"placeholder",style:({ width })})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }